module.exports = __webpack_public_path__ + "img/TopupEN.67eae439.png";